import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Holidays($page: Int, $perPage: Int, $search: String) {
    Holidays(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        title
        holidayDate
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  title: string;
  holidayDate: Date;
}

export interface GetAllGql {
  Holidays: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
